export function getParentPath(path: string): string {
  const pathArray = path.split('/')
  pathArray.pop()
  return pathArray.join('/')
}
